import { render, staticRenderFns } from "./previewImgFile.vue?vue&type=template&id=8bace132&scoped=true&"
import script from "./previewImgFile.vue?vue&type=script&lang=js&"
export * from "./previewImgFile.vue?vue&type=script&lang=js&"
import style0 from "./previewImgFile.vue?vue&type=style&index=0&id=8bace132&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bace132",
  null
  
)

export default component.exports